var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDatareport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.598,
    height: 39.54,
    viewBox: "0 0 34.598 39.54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#6f7072;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M2,37.069A2.472,2.472,0,0,0,4.471,39.54H34.127A2.472,2.472,0,0,0,36.6,37.069V2.471A2.472,2.472,0,0,0,34.127,0H4.471A2.472,2.472,0,0,0,2,2.471Zm2.471-34.6H34.127v34.6H4.471Zm4.943,19.77h4.943v9.885H9.414ZM16.828,9.885H21.77V32.127H16.828Zm7.414,4.943h4.943v17.3H24.241Z",
    transform: "translate(-2)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDatareport);
export default __webpack_public_path__ + "static/media/icon_datareport.ec68a9e4.svg";
export { ForwardRef as ReactComponent };